import React from "react";

const SKELETON_ROW_COUNT = 6;
const SKELETON_ROW_INDEXES = Array.from({ length: SKELETON_ROW_COUNT }, (unusedSlot, rowIndex) => rowIndex);

type EntriesListSkeletonProps = {
  "data-testid"?: string;
};

function SkeletonRow({ testId }: { testId: string }) {
  return (
    <div className="flex flex-col gap-2 rounded-xl bg-gray-5 p-3" data-testid={testId}>
      <div className="h-3.5 w-1/2 rounded-md bg-gray-8" />
      <div className="h-2.5 w-full rounded-md bg-gray-8" />
      <div className="h-2.5 w-3/4 rounded-md bg-gray-8" />
    </div>
  );
}

function EntriesListSkeleton({ "data-testid": testId = "EntriesListSkeleton" }: EntriesListSkeletonProps) {
  return (
    <div className="mt-2.5 flex flex-col gap-2" data-testid={testId}>
      {SKELETON_ROW_INDEXES.map((rowIndex) => (
        <SkeletonRow key={`skeleton-row-${rowIndex}`} testId={`${testId}-Row`} />
      ))}
    </div>
  );
}

export default React.memo(EntriesListSkeleton);
